import React, { memo, useCallback, useMemo, useState } from 'react';
import Animated, { runOnJS, useAnimatedStyle, useDerivedValue, withTiming, } from 'react-native-reanimated';
import { StyleSheet } from 'react-native';
import { rem } from 'design-system/values';
import IconCircle from 'design-system/icons/IconCircle';
import IconTransactionCategory from 'features/transactions/icons/IconTransactionCategory';
import { useColorOfCategory } from 'hooks/useCategory';
import useColors from 'hooks/useColors';
import { calculateAndFormatPercentage } from 'utils/formatting';
import AnalyticsRow from './AnalyticsRow';
import { isWeb } from '../../../../constants';
const RowCategory = ({ category, totalSpending, showExpensePercentage, onPress, onPressUpgrade, onLayout, selectable, selectedCategoryId, blurValue, }) => {
    const colors = useColors();
    const press = useCallback(() => {
        onPress?.({ type: 'category', data: category });
    }, [category, onPress]);
    const isSelectedSharedValue = useDerivedValue(() => selectedCategoryId?.value === category.id, [selectedCategoryId, category]);
    const [isSelected, setIsSelected] = useState(selectedCategoryId?.value === category.id);
    useDerivedValue(() => {
        runOnJS(setIsSelected)(selectedCategoryId?.value === category.id);
    }, [category.id, selectedCategoryId]);
    const totalAmount = category.hideFromStats
        ? category.totalWithExcluded ?? 0
        : category.total;
    const percentage = useMemo(() => {
        if (!showExpensePercentage)
            return '';
        return calculateAndFormatPercentage(Math.abs(totalAmount), Math.abs(totalSpending ?? 0));
    }, [showExpensePercentage, totalAmount, totalSpending]);
    const categoryColor = useColorOfCategory()(category);
    const animatedStyle = useAnimatedStyle(() => ({
        opacity: withTiming(isSelectedSharedValue.value ? 1 : 0),
    }), [isSelectedSharedValue]);
    return (<AnalyticsRow onLayout={onLayout} displayName={category.displayName} total={totalAmount} percentage={percentage} count={category.transactionsCount} currency={category.currency} onPress={onPress ? press : undefined} onPressUpgrade={onPressUpgrade} icon={<IconCircle width={44} height={44}>
          {selectable ? (<>
              <Animated.View style={[
                    styles.animatedBackground,
                    { backgroundColor: categoryColor },
                    animatedStyle,
                ]}/>
              <IconTransactionCategory category={category} color={isSelected
                    ? colors.background.dark
                    : colors.text.tertiary} emojiBackgroundColor={colors.background.fullTransparent}/>
            </>) : (<IconTransactionCategory category={category}/>)}
        </IconCircle>} blurValue={blurValue}/>);
};
const styles = StyleSheet.create({
    animatedBackground: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        position: 'absolute',
        borderRadius: rem(44),
        // On web the icon is a static <svg>, which an absolute sibling covers
        ...(isWeb && { zIndex: -1 }),
    },
});
export default memo(RowCategory);
